import axios from 'axios';
import router from '@/router';
import store from '@/store';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response ? error.response.status : null;
    const urlOriginal = originalRequest.url;

    if (
      status === 401 && 
      !originalRequest._retry && 
      !urlOriginal.includes('/usuarios/login/') && 
      !urlOriginal.includes('/usuarios/token/refresh/')
    ) {
      
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => apiClient(originalRequest))
          .catch(err => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        await apiClient.post('/usuarios/token/refresh/'); 
        
        isRefreshing = false;
        processQueue(null);
        return apiClient(originalRequest);

      } catch (refreshError) {
        isRefreshing = false;
        processQueue(refreshError, null);

        localStorage.removeItem('userData');
        localStorage.removeItem('usuario');
        localStorage.removeItem('rolUsuario');
        localStorage.removeItem('nombreUsuario');

        store.commit('setSessionExpired', true);

        setTimeout(() => {
          store.commit('setSessionExpired', false);
          router.push('/');
        }, 3500);

        return Promise.reject(refreshError);
      }
    }

    if (status === 401 && urlOriginal.includes('/usuarios/token/refresh/')) {
        localStorage.clear();
        store.commit('setSessionExpired', true);
        setTimeout(() => {
          store.commit('setSessionExpired', false);
          router.push('/');
        }, 2500);
    }

    return Promise.reject(error);
  }
);

export default apiClient;